<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.Status') || '功能状态'"
            prop="functionStatus"
          >
            <el-radio-group v-model="formData.functionStatus" :disabled="isAdd">
              <el-radio label="Y">{{
                $l('form_label_functionStatus_Y') || '可用'
              }}</el-radio>
              <el-radio label="N">{{
                $l('form_label_functionStatus_N') || '不可用'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_functionCode') || '功能编码'"
            prop="functionCode"
          >
            <el-input
              clearable
              v-model="formData.functionCode"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
              :disabled="!this.isAdd"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_functionName') || '功能名称'"
            prop="functionName"
          >
            <el-input
              clearable
              v-model="formData.functionName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_sourceTableName') || '数据表名'"
            prop="sourceTableName"
          >
            <el-input
              clearable
              v-model="formData.sourceTableName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_keyColumnName') || '主键字段'"
            prop="keyColumnName"
          >
            <el-input
              clearable
              v-model="formData.keyColumnName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_apiServerName') || 'API服务器名'"
            prop="apiServerName"
          >
            <dict-select
              v-model="formData.apiServerName"
              :body="{ dictType: 'apiServerName' }"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              url="/sys/common/dict/system"
              size="small"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_apiApprovalPath') || '审核通过路径'"
          >
            <el-input
              clearable
              v-model="formData.apiApprovalPath"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_apiRejectPath') || '审核拒绝路径'"
          >
            <el-input
              clearable
              v-model="formData.apiRejectPath"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_apiModifyPath') || '审核修改路径'"
          >
            <el-input
              clearable
              v-model="formData.apiModifyPath"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_querySql') || '查询语句'">
            <el-input
              v-model="formData.querySql"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              type="textarea"
              rows="3"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    functionCode: String,
    isAdd: Boolean,
    params: { type: Object, default: () => {} }
  },
  data() {
    return {
      formData: { functionStatus: 'Y' },
      rules: {
        functionStatus: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change'
          }
        ],
        functionCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur'
          }
        ],
        functionName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur'
          }
        ],
        sourceTableName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur'
          }
        ],
        keyColumnName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur'
          }
        ],
        apiServerName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getData()
  },
  computed: {},
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.functionCode) return

      this.$api
        .sysOaConfigureDetailApi({
          functionCode: this.functionCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      let $api = null
      if (this.isAdd) {
        $api = this.$api.sysOaConfigureSaveApi(this.formData)
      } else {
        $api = this.$api.sysOaConfigureEditApi(this.formData)
      }
      $api
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success'
          })
          if (this.isAdd) {
            this.closeCurPage()
          } else {
            this.getData()
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },

    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false
      })
    }
  }
}
</script>
